import { Error } from '@/components/error';

const ErrorServer = () => <Error variant='server' />;

export { ErrorServer };
